<section ngClass.gt-sm="large">
  <div class="dialog-title">
    <h2>{{ ('ai.acceptTitleDialog' | translate) }}</h2>
  </div>
  <div class="mat-body dialog-message" mat-dialog-content>
    <span>{{ ('ai.acceptMessageDialog' | translate) }}</span>
    <mat-checkbox [(ngModel)]="agreementChecked" class="agreement-checkbox">
      <span [innerHTML]="'ai.readTermsAndConditions' | translate"></span>
    </mat-checkbox>
  </div>
  <mat-toolbar
    fxLayout="row"
    fxLayoutAlign="flex-end flex-end"
    fxLayoutGap="20px"
    fxLayout.lt-sm="column"
    fxLayoutGap.lt-sm="12px"
    ngClass.lt-sm="mobile"
  >
    <button mat-stroked-button color="darkblue" [mat-dialog-close]="false">
      {{ ('common.cancel' | translate) }}
    </button>
    <button
      class="no-border filled"
      color="yellow"
      mat-stroked-button
      (click)="onConfirm()"
      [disabled]="!agreementChecked"
    >
      {{ 'common.confirm' | translate }}
    </button>
  </mat-toolbar>
</section>
